module.exports = __webpack_public_path__ + "static/media/Dec404.td.0f6b8362.tsx";